export const defaultValue = {
    colors: {
        light: "#EDF2F4",
        dark: "#252422",
        main: "#de8e3f",
        mild: "#c0a49c",
        darkFont: "#332B25",
        btnFont: "#877A6E",
        shadow: "rgba(39, 39, 39, 0.623)",
    },
    mobile: "550px",
    tablet: "1050px",
    minWidth: "340px",
    maxWidth: "2000px",
};